import { produce } from "immer";
import {
  FETCH_RESIDENT,
  FETCH_RESIDENT_SUCCESS,
  FETCH_RESIDENT_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_RESIDENT,
  ADD_RESIDENT_SUCCESS,
  ADD_RESIDENT_FAILURE,
  //
  EDIT_RESIDENT,
  EDIT_RESIDENT_SUCCESS,
  EDIT_RESIDENT_FAILURE,
  //
  DELETE_RESIDENT,
  DELETE_RESIDENT_SUCCESS,
  DELETE_RESIDENT_FAILURE,
  //
  TOGGLE_RESIDENT_MODAL,
  TOGGLE_BELONGINGS_MODAL,
  //
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  //
  FETCH_BELONGINGS,
  FETCH_BELONGINGS_SUCCESS,
  FETCH_BELONGINGS_FAILURE,
  //
  ADD_BELONGING,
  ADD_BELONGING_SUCCESS,
  ADD_BELONGING_FAILURE,
  //
  DELETE_BELONGING,
  DELETE_BELONGING_SUCCESS,
  DELETE_BELONGING_FAILURE,
  //
  GET_RESIDENT_DATA,
  GET_RESIDENT_DATA_SUCCESS,
  GET_RESIDENT_DATA_FAILURE,
  //
  GET_DOC_STATUS,
  GET_DOC_STATUS_SUCCESS,
  GET_DOC_STATUS_FAILURE,
  //
  GET_TIMELINE,
  GET_TIMELINE_SUCCESS,
  GET_TIMELINE_FAILURE,
  //
  LOAD_MORE_TIMELINE,
  LOAD_MORE_TIMELINE_SUCCESS,
  LOAD_MORE_TIMELINE_FAILURE,
  //
  GET_MY_ASSESSMENTS,
  GET_MY_ASSESSMENTS_SUCCESS,
  GET_MY_ASSESSMENTS_FAILURE,
  //
  GET_OVERVIEW,
  GET_OVERVIEW_SUCCESS,
  GET_OVERVIEW_FAILURE,
  //
  CONVERT_RESIDENT,
  CONVERT_RESIDENT_SUCCESS,
  CONVERT_RESIDENT_FAILURE,
  //
  UPDATE_RESIDENT_STATUS,
  UPDATE_RESIDENT_STATUS_SUCCESS,
  UPDATE_RESIDENT_STATUS_FAILURE,
  //
  GET_TIMELINE_INFO,
  GET_TIMELINE_INFO_SUCCESS,
  GET_TIMELINE_INFO_FAILURE,
  //
  GET_PRE_ASSESSMENT,
  GET_PRE_ASSESSMENT_SUCCESS,
  GET_PRE_ASSESSMENT_FAILURE,
  //
  GET_ASSESSMENT_FORM,
  GET_ASSESSMENT_FORM_SUCCESS,
  GET_ASSESSMENT_FORM_FAILURE,
  //
  GET_DOC_QR_CODE,
  GET_DOC_QR_CODE_SUCCESS,
  GET_DOC_QR_CODE_FAILURE,
  //
  ADD_PRE_ASSESSMENT,
  ADD_PRE_ASSESSMENT_SUCCESS,
  ADD_PRE_ASSESSMENT_FAILURE,
  //
  EDIT_PRE_ASSESSMENT,
  EDIT_PRE_ASSESSMENT_SUCCESS,
  EDIT_PRE_ASSESSMENT_FAILURE,
  //
  FETCH_RESIDENT_ALERTS_REVIEW,
  FETCH_RESIDENT_ALERTS_REVIEW_SUCCESS,
  FETCH_RESIDENT_ALERTS_REVIEW_FAILURE,
  //
  FETCH_SCHEDULED_REPORT,
  FETCH_SCHEDULED_REPORT_SUCCESS,
  FETCH_SCHEDULED_REPORT_FAILURE,
  //
  EXPORT_HOSPITAL_REPORT,
  EXPORT_HOSPITAL_REPORT_SUCCESS,
  EXPORT_HOSPITAL_REPORT_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingResident: false,
  isSubmitting: false,
  isDeleting: false,
  isFetching: false,
  currentResident: {},
  residents: [],
  residentModal: {
    open: false,
    type: null,
  },
  isUpdatingProfile: false,
  belongingsModal: {
    open: false,
  },
  belongings: {},
  isFetchingBelongings: false,
  isSubmittingBelongings: false,
  isDeletingBelongings: false,
  //
  isFetchingResidentData: false,
  residentData: {},
  //
  isFetchingDocStatus: false,
  docStatus: {},
  //
  isFetchingTimeline: false,
  timeline: [],
  //
  isFetchingMyAssessments: false,
  myAssessments: [],
  //
  isFetchingOverview: false,
  overview: {},
  //
  isConvertingResident: false,
  //
  isUpdatingResidentStatus: false,
  //
  isFetchingTimelineInfo: false,
  timelineInfo: {},
  //
  isFetchingPreAssessment: false,
  preAssessment: {},
  //
  isFetchingAssessmentForm: false,
  assessmentForm: {},
  //
  isFetchingDocQRCode: false,
  //
  isAddingPreAssessment: false,
  //
  isEditingPreAssessment: false,
  //
  reviewAlerts: null,
  isFetchingResidentAlertsReview: false,
  //
  isFetchingScheduledReport: false,
  scheduledReportData: null,
  //
  isExportingHospitalReport: false,
};

const ResidentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_RESIDENT:
        draft.isFetchingResident = true;
        draft.residents = [];
        break;
      case FETCH_RESIDENT_SUCCESS:
        draft.isFetchingResident = false;
        draft.residents = action.payload;
        break;
      case FETCH_RESIDENT_FAILURE:
        draft.isFetchingResident = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentResident = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_RESIDENT:
        draft.isSubmitting = true;
        break;
      case ADD_RESIDENT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_RESIDENT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_RESIDENT:
        draft.isSubmitting = true;
        break;
      case EDIT_RESIDENT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_RESIDENT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_RESIDENT:
        draft.isDeleting = true;
        break;
      case DELETE_RESIDENT_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_RESIDENT_FAILURE:
        draft.isDeleting = false;
        break;
      // Modal
      case TOGGLE_RESIDENT_MODAL:
        draft.residentModal = action.payload;
        break;
      // Update Profile
      case UPDATE_PROFILE:
        draft.isUpdatingProfile = true;
        break;
      case UPDATE_PROFILE_SUCCESS:
        draft.isUpdatingProfile = false;
        break;
      case UPDATE_PROFILE_FAILURE:
        draft.isUpdatingProfile = false;
        break;
      // Belongings Modal
      case TOGGLE_BELONGINGS_MODAL:
        draft.belongingsModal = action.payload;
        break;
      // Belongings
      case FETCH_BELONGINGS:
        draft.isFetchingBelongings = true;
        draft.belongings = {};
        break;
      case FETCH_BELONGINGS_SUCCESS:
        draft.isFetchingBelongings = false;
        draft.belongings = action.payload;
        break;
      case FETCH_BELONGINGS_FAILURE:
        draft.isFetchingBelongings = false;
        break;
      // Add Belonging
      case ADD_BELONGING:
        draft.isSubmittingBelongings = true;
        break;
      case ADD_BELONGING_SUCCESS:
        draft.isSubmittingBelongings = false;
        break;
      case ADD_BELONGING_FAILURE:
        draft.isSubmittingBelongings = false;
        break;
      // Delete Belonging
      case DELETE_BELONGING:
        draft.isDeletingBelongings = true;
        break;
      case DELETE_BELONGING_SUCCESS:
        draft.isDeletingBelongings = false;
        break;
      case DELETE_BELONGING_FAILURE:
        draft.isDeletingBelongings = false;
        break;

      // Get Resident Data
      case GET_RESIDENT_DATA:
        draft.isFetchingResidentData = true;
        draft.residentData = {};
        break;
      case GET_RESIDENT_DATA_SUCCESS:
        draft.isFetchingResidentData = false;
        draft.residentData = action.payload;
        break;
      case GET_RESIDENT_DATA_FAILURE:
        draft.isFetchingResidentData = false;
        break;

      // Get Doc Status
      case GET_DOC_STATUS:
        draft.isFetchingDocStatus = true;
        draft.docStatus = {};
        break;
      case GET_DOC_STATUS_SUCCESS:
        draft.isFetchingDocStatus = false;
        draft.docStatus = action.payload;
        break;
      case GET_DOC_STATUS_FAILURE:
        draft.isFetchingDocStatus = false;
        break;

      // Get Timeline
      case GET_TIMELINE:
        draft.isFetchingTimeline = true;
        draft.timeline = [];
        break;
      case GET_TIMELINE_SUCCESS:
        draft.isFetchingTimeline = false;
        draft.timeline = action.payload;
        break;
      case GET_TIMELINE_FAILURE:
        draft.isFetchingTimeline = false;
        draft.timeline = [];
        break;

      // Load More Timeline (Infinite Scroll)
      case LOAD_MORE_TIMELINE:
        draft.isFetchingTimeline = true;
        break;
      case LOAD_MORE_TIMELINE_SUCCESS:
        draft.isFetchingTimeline = false;
        // Merge new log entries with existing logs
        // API structure: { current_page, data: [logEntries], next_page_url, ... }
        if (draft.timeline && draft.timeline.data && action.payload.data) {
          const existingLogs = Array.isArray(draft.timeline.data)
            ? draft.timeline.data
            : [];
          const newLogs = Array.isArray(action.payload.data)
            ? action.payload.data
            : [];

          // Merge logs (new logs appended to existing)
          // The component will handle sorting and grouping by date
          draft.timeline = {
            ...action.payload,
            data: [...existingLogs, ...newLogs],
          };
        } else {
          draft.timeline = action.payload;
        }
        break;
      case LOAD_MORE_TIMELINE_FAILURE:
        draft.isFetchingTimeline = false;
        break;

      // Get My Assessments
      case GET_MY_ASSESSMENTS:
        draft.isFetchingMyAssessments = true;
        draft.myAssessments = [];
        break;
      case GET_MY_ASSESSMENTS_SUCCESS:
        draft.isFetchingMyAssessments = false;
        draft.myAssessments = action.payload;
        break;
      case GET_MY_ASSESSMENTS_FAILURE:
        draft.isFetchingMyAssessments = false;
        draft.myAssessments = [];
        break;

      // Get Overview
      case GET_OVERVIEW:
        draft.isFetchingOverview = true;
        draft.overview = {};
        break;
      case GET_OVERVIEW_SUCCESS:
        draft.isFetchingOverview = false;
        draft.overview = action.payload;
        break;
      case GET_OVERVIEW_FAILURE:
        draft.isFetchingOverview = false;
        draft.overview = {};
        break;

      // Convert Resident
      case CONVERT_RESIDENT:
        draft.isConvertingResident = true;
        break;
      case CONVERT_RESIDENT_SUCCESS:
        draft.isConvertingResident = false;
        break;
      case CONVERT_RESIDENT_FAILURE:
        draft.isConvertingResident = false;
        break;

      // Update Resident Status
      case UPDATE_RESIDENT_STATUS:
        draft.isUpdatingResidentStatus = true;
        break;
      case UPDATE_RESIDENT_STATUS_SUCCESS:
        draft.isUpdatingResidentStatus = false;
        break;
      case UPDATE_RESIDENT_STATUS_FAILURE:
        draft.isUpdatingResidentStatus = false;
        break;

      // Get Timeline Info
      case GET_TIMELINE_INFO:
        draft.isFetchingTimelineInfo = true;
        draft.timelineInfo = {};
        break;
      case GET_TIMELINE_INFO_SUCCESS:
        draft.isFetchingTimelineInfo = false;
        draft.timelineInfo = action.payload;
        break;
      case GET_TIMELINE_INFO_FAILURE:
        draft.isFetchingTimelineInfo = false;
        break;

      // Get Pre Assessment
      case GET_PRE_ASSESSMENT:
        draft.isFetchingPreAssessment = true;
        draft.preAssessment = {};
        break;
      case GET_PRE_ASSESSMENT_SUCCESS:
        draft.isFetchingPreAssessment = false;
        draft.preAssessment = action.payload;
        break;
      case GET_PRE_ASSESSMENT_FAILURE:
        draft.isFetchingPreAssessment = false;
        break;

      // Get Assessment Form
      case GET_ASSESSMENT_FORM:
        draft.isFetchingAssessmentForm = true;
        draft.assessmentForm = {};
        break;
      case GET_ASSESSMENT_FORM_SUCCESS:
        draft.isFetchingAssessmentForm = false;
        draft.assessmentForm = action.payload;
        break;
      case GET_ASSESSMENT_FORM_FAILURE:
        draft.isFetchingAssessmentForm = false;
        draft.assessmentForm = {};
        break;

      // Get Doc QR Code
      case GET_DOC_QR_CODE:
        draft.isFetchingDocQRCode = true;
        break;
      case GET_DOC_QR_CODE_SUCCESS:
        draft.isFetchingDocQRCode = false;
        break;
      case GET_DOC_QR_CODE_FAILURE:
        draft.isFetchingDocQRCode = false;
        break;

      // Add Pre Assessment
      case ADD_PRE_ASSESSMENT:
        draft.isAddingPreAssessment = true;
        break;
      case ADD_PRE_ASSESSMENT_SUCCESS:
        draft.isAddingPreAssessment = false;
        break;
      case ADD_PRE_ASSESSMENT_FAILURE:
        draft.isAddingPreAssessment = false;
        break;
      // Edit Pre Assessment
      case EDIT_PRE_ASSESSMENT:
        draft.isEditingPreAssessment = true;
        break;
      case EDIT_PRE_ASSESSMENT_SUCCESS:
        draft.isEditingPreAssessment = false;
        break;
      case EDIT_PRE_ASSESSMENT_FAILURE:
        draft.isEditingPreAssessment = false;
        break;

      // AI alerts review
      case FETCH_RESIDENT_ALERTS_REVIEW:
        draft.isFetchingResidentAlertsReview = true;
        break;
      case FETCH_RESIDENT_ALERTS_REVIEW_SUCCESS:
        draft.isFetchingResidentAlertsReview = false;
        draft.reviewAlerts = action.payload;
        break;
      case FETCH_RESIDENT_ALERTS_REVIEW_FAILURE:
        draft.isFetchingResidentAlertsReview = false;
        draft.reviewAlerts = null;
        break;

      // Scheduled Report
      case FETCH_SCHEDULED_REPORT:
        draft.isFetchingScheduledReport = true;
        break;
      case FETCH_SCHEDULED_REPORT_SUCCESS:
        draft.isFetchingScheduledReport = false;
        draft.scheduledReportData = action.payload;
        break;
      case FETCH_SCHEDULED_REPORT_FAILURE:
        draft.isFetchingScheduledReport = false;
        draft.scheduledReportData = null;
        break;

      // Hospital report PDF export
      case EXPORT_HOSPITAL_REPORT:
        draft.isExportingHospitalReport = true;
        break;
      case EXPORT_HOSPITAL_REPORT_SUCCESS:
      case EXPORT_HOSPITAL_REPORT_FAILURE:
        draft.isExportingHospitalReport = false;
        break;

      default:
        return state;
    }
  });

export default ResidentReducer;
